import styled from 'styled-components';
import { space, SpaceProps, height, HeightProps, width, WidthProps, minWidth, color, ColorProps } from 'styled-system';

export type StyledLogoProps = SpaceProps & HeightProps & WidthProps & ColorProps;

export const StyledLogo = styled.svg.attrs(p => ({ minWidth: p.width }))<StyledLogoProps>`
  display: block;
  ${space};
  ${height};
  ${width};
  ${minWidth};
  ${color};
`;
